var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.inProgress)?_c('p',[_vm._v(" Zahlungsmethode wird gespeichert "),_c('b-spinner')],1):_vm._e(),(_vm.success)?_c('p',[_vm._v("Die Zahlungsmethode wurde erfolgreich gespeichert.")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }